'use strict';

/**
 * @ngdoc function
 * @name pwrApp.controller:MarketingAndSupportCtrl
 * @description
 * # MarketingAndSupportCtrl
 * Controller of the pwrApp
 */
angular
  .module('myConsultApp')
  .controller(
    'MarketingAndSupportCtrl',
    function ($scope, $location, crumble, $cookieStore, OrganizationsService) {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      $scope.crumble = crumble;
      crumble.update();
    },
  );
